import { IdentityService } from "@common/identity/identity.service";
import { DocumentSelectorService } from "@common/ux/document-selector/document-selector.service";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { combineLatest } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

// update document selector organisation Id when org changes
export function initialiseDocumentSelector(
    organisationService: OrganisationService,
    identityService: IdentityService,
    documentSelectorService: DocumentSelectorService,
) {
    // combine with identityService init to wait for cookies to be set before calling RetrieveFile for adaptbydesign_item_test_id
    combineLatest([
        organisationService.organisationEntityUpdated$,
        identityService.initialisation$,
    ]).pipe(
        // only care when the org has changed
        distinctUntilChanged(([prevOrg], [currOrg]) => prevOrg === currOrg),
    ).subscribe(([org]) => documentSelectorService.setOrganisationId(org?.organisationId));
}
